module.exports = __webpack_public_path__ + "img/profile_hdtool.fb777b5b.png";